import { queryRequest } from './client';
import { getSearch } from './queries';
import SearchResult from '../models/SearchResult';

/**
 * Fetch search results from the universal api
 * @param {string} query
 * @returns {Array} collections
 */
export const fetchSearch = async (query) => {
  const { data } =
    (await queryRequest({
      query: getSearch,
      variables: { query },
    })) || {};
  return new SearchResult(data);
};
